module.exports = __webpack_public_path__ + "img/744.de06d71c.jpg";